exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Audio-module__wrapper___y6Val{display:grid}.Audio-module__wrapper___y6Val .Audio-module__block___39hNH{min-width:300px;display:flex;flex-direction:column;padding:2.2em;background-color:#fff;border-radius:10px;gap:1.5em}.Audio-module__wrapper___y6Val .Audio-module__block___39hNH h3{text-align:center}.Audio-module__wrapper___y6Val .Audio-module__block___39hNH h3 span{color:#1368e5;cursor:pointer}.Audio-module__wrapper___y6Val .Audio-module__block___39hNH .Audio-module__row___ax-xQ{display:flex;flex-direction:row;gap:1em;justify-content:center}", ""]);

// exports
exports.locals = {
	"wrapper": "Audio-module__wrapper___y6Val",
	"block": "Audio-module__block___39hNH",
	"row": "Audio-module__row___ax-xQ"
};